import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CHECKOUT_URL } from '../data/content';
export function Guarantee() {
  return <section className="w-full bg-brand px-5 py-20 sm:px-8" data-id="element-85" data-mp="223emlohxbf51">
      <Reveal className="mx-auto w-full max-w-2xl" data-id="element-86" data-mp="222whs3h73sli">
        <div className="rounded-card bg-white px-6 py-12 text-center shadow-xl sm:px-12" data-id="element-87" data-mp="1x4l9hx6jtq5e">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold" data-id="element-88" data-mp="19eqyll5sibns">
            <ShieldCheckIcon className="h-8 w-8 text-navy" aria-hidden="true" data-id="element-89" data-mp="14fxsidsu1mxn" />
          </span>

          <h2 className="mt-6 font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-90" data-mp="1j4afil9xzvg0">
            7-Day Guarantee
          </h2>

          <p className="mx-auto mt-5 max-w-lg text-base leading-relaxed text-navy/75" data-id="element-91" data-mp="1ec97xcnpyswb">
            If Flag Football Ready isn't right for you, contact us within 7 days of
            purchase for a full refund.
          </p>

          <a href={CHECKOUT_URL} className="mt-8 inline-flex items-center py-1 justify-center border-b-2 border-brand-deep font-display text-sm font-extrabold uppercase tracking-tight text-brand-deep transition-colors duration-150 ease-out hover:border-navy hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40" data-id="element-92" data-mp="ln27270slr7w">
            Get Flag Football Ready risk-free
          </a>
        </div>
      </Reveal>
    </section>;
}